import "./layout.scss";
import { useState, useEffect, useContext, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import useWindowSize from "../../../hooks/useWindowSize";
import Canvas from "../Canvas.jsx";
import { CustomTooltip } from "../tooltip/CustomTooltip.jsx";
import { CustomInput } from "../Inputs/Inputs.tsx";
import SideBar from "./SideBar.jsx";

import UseFullDataContext from "../../../context/UseFullData";
// icons

import MassagePreview from "../../chat/modals/MassagePreview";
// import ChatWidget from "../chat_widget/ChatWidget";
import { CloseIcon, ListIcon, SearchIcon } from "../Icons.tsx";
import { NavLink, useLocation } from "react-router-dom";
import ColorSchema from "../Color/index.tsx";

import SearchInputContext from "../../../Search/SearchInput";
import image from "../../../assets/images/arrow-left-gray.png";
export default function Layout({ children }) {
  const winSize = useWindowSize();
  const location = useLocation();
  const [selectedItem, setSelectedItem] = useState(location.pathname);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [showCanvas, setShowCanvas] = useState(false);
  const [searchBox, setSearchBox] = useState(false);

  const { factorDataForPrint } = useContext(UseFullDataContext);
  console.log("factorDataForPrint", factorDataForPrint);
  // const [searchInput, setSearchInput] = useState("");
  const { searchInput, setInputData } = useContext(SearchInputContext);

  useEffect(() => {
    if (winSize.width > 992) {
      setOpenSidebar(true);
    } else {
      setOpenSidebar(false);
    }
  }, [winSize.width]);
  useEffect(() => {
    setSelectedItem(location.pathname);
    setInputData("");
  }, [location.pathname]);

  return (
    <div>
      <div
        className="d-flex layout-styles "
        style={{ backgroundColor: "#f3f4f4", height: "100%" }}
      >
        {/* {location["pathname"] != "/chat" && <ChatWidget page={false} />} */}

        <div
          style={{
            minHeight: "100vh",
            // height: "100%",
            backgroundColor: "#f3f4f4",
            display: openSidebar ? "block" : "none",
            boxShadow: "0 0 0 1px #d4d8dd",
          }}
        >
          <SideBar
            type="main"
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
          />
        </div>
        <div className="w-100 " style={{ minHeight: "100vh" }}>
          <div
            className="d-flex justify-content-between align-items-center w-100 position-relative"
            style={{ height: 62, padding: "0 1% 0 2%" }}
          >
            <div className="d-flex align-items-baseline ">
              {" "}
              <button
                className="btn btnOnFocus"
                style={{ display: winSize.width > 992 ? "none" : "inline" }}
                onClick={() => {
                  setShowCanvas(true);
                }}
              >
                <ListIcon
                  style={{
                    width: 25,
                    height: 25,
                    color: ColorSchema.secondary_custom,
                  }}
                />
              </button>
              <div
                className="d-flex align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setSearchBox(true);
                }}
              >
                <SearchIcon
                  style={{
                    width: 25,
                    height: 25,
                    color: ColorSchema.secondary_custom,
                  }}
                />
                <span
                  className="mx-2"
                  style={{
                    color: ColorSchema.secondary_custom,
                    display: winSize.width > 768 ? "inline-block" : "none",
                  }}
                >
                  جستجو (\+Ctrl)
                </span>
              </div>
            </div>
            {searchBox && (
              <div
                className="d-flex justify-content-between align-items-center position-absolute px-4 mt-0 pt-0"
                style={{
                  width: "100%",
                  backgroundColor: "#f3f4f4",
                  top: 0,
                  left: 0,
                  height: 60,
                  zIndex: "1001",
                }}
              >
                <div className="w-75">
                  <CustomInput
                    type="text"
                    placeholder="جستجو ..."
                    plaintext={true}
                    inputValue={searchInput}
                    onChangeFunc={(e) => {
                      setInputData(e.target.value);
                    }}
                  />
                </div>
                <div
                  onClick={() => {
                    setSearchBox(false);
                    setInputData("");
                  }}
                >
                  <CloseIcon />
                </div>
              </div>
            )}
            <Canvas
              show={showCanvas}
              setShow={setShowCanvas}
              placement="start"
              width={320}
              bgColor="#f3f4f4"
            >
              <SideBar
                type="offcanvas"
                setShowCanvas={setShowCanvas}
                showCanvas={showCanvas}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
              />
            </Canvas>

            <div className="d-flex align-items-center">{/* left navbar */}</div>
          </div>

          {children}
        </div>
      </div>
      <div className="print-factor">{factorDataForPrint?.id}</div>
    </div>
  );
}
